export const GAME_BALANCE = {

	correcta: {
		xp: 10,
		corrupcion: -2,
		streak: 1
	},

	incorrecta: {
		xp: 5,
		corrupcion: 8,
		resetStreak: true
	},

	noEntiendo: {
		xp: 3,
		corrupcion: 0,
		conservarStreak: true
	}
};

export const STREAK_MULTIPLIERS = {
	3: 1.2,
	5: 1.5,
	10: 2,
	20: 3
};